import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Pagin from 'src/components/common/Pagin';
import { getDetailPagin } from 'src/common/helper';

const QuoteTab = (props: any) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table
          sx={{
            minWidth: 650,
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '1px solid #F3F3F3',
              fontWeight: 700,
              p: '6px 16px',
              fontSize: '14px',
              minWidth: '100px',
            },
            '& .MuiTableCell-root.MuiTableCell-body': {
              color: 'primary.dark',
              fontSize: '14px',
              py: '10px',
            },
          }}
          aria-label='simple table'
        >
          <TableHead>
            <TableRow>
              <TableCell>見積ID</TableCell>
              <TableCell>患者ID</TableCell>
              <TableCell>患者名</TableCell>
              <TableCell>医師</TableCell>
              <TableCell>見積タイプ</TableCell>
              <TableCell>タイトル</TableCell>
              <TableCell>施術名</TableCell>
              <TableCell>カテゴリー</TableCell>
              <TableCell>物販名</TableCell>
              <TableCell>発行日</TableCell>
              <TableCell>実施日</TableCell>
              <TableCell>通常のみ</TableCell>
              <TableCell>価格タイプ</TableCell>
              <TableCell>患者選択</TableCell>
              <TableCell>数量</TableCell>
              <TableCell>通常価格</TableCell>
              <TableCell>サロン価格</TableCell>
              <TableCell>金額</TableCell>
              <TableCell>ステータス</TableCell>
              <TableCell>担当者</TableCell>
              <TableCell>備考</TableCell>
              <TableCell>返金</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data.map((row: any, index: number) => (
              <TableRow
                key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell>{row.quoteid}</TableCell>
                <TableCell>{row.patientno}</TableCell>
                <TableCell>{row.fullname}</TableCell>
                <TableCell>{row.doctor}</TableCell>
                <TableCell>{row.quotetype}</TableCell>
                <TableCell>{row.title}</TableCell>
                <TableCell>{row.surgery}</TableCell>
                <TableCell>{row.category}</TableCell>
                <TableCell>{row.product}</TableCell>
                <TableCell>{row.quotedate}</TableCell>
                <TableCell>{row.reserveday}</TableCell>
                <TableCell>{row.normal_only}</TableCell>
                <TableCell>{row.discount}</TableCell>
                <TableCell>{row.patient_select_text}</TableCell>
                <TableCell>{row.qty}</TableCell>
                <TableCell>{row.price}</TableCell>
                <TableCell>{row.discount_price}</TableCell>
                <TableCell>{row.amount}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.person}</TableCell>
                <TableCell>{row.note}</TableCell>
                <TableCell>
                  {row.has_refund === 0 ? '' : row.has_refund}
                </TableCell>
              </TableRow>
            ))}
            {props.data.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={22}
                  sx={{ textAlign: 'center', verticalAlign: 'center' }}
                >
                  データがありません
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.data.length > 0 && props.pagination && (
        <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
          <Typography
            component='label'
            sx={{
              color: '#AAB2BD',
              fontWeight: '400',
              fontSize: '10px',
              lineHeight: '12px',
            }}
          >
            {getDetailPagin(props.pagination)}
          </Typography>
        </Box>
      )}
      {props.data.length > 0 && props.pagination && props.pagination.page && (
        <Pagin
          handlePageChange={props.handlePageChange}
          pagination={props.pagination}
        />
      )}
    </>
  );
};

export default QuoteTab;
